<template>

    <Grid>

        <AOS type="fade-up" duration="800" delay="1000">

            <Column :span="[ 2, 1 ]">

                <Paragraph v-html="data.label" heading/>

            </Column>

            <Column :span="[ 2, 5 ]" class="testimonial__quote sm:mt-8">

                <div class="p-6 md:py-14 md:px-16">

                    <Paragraph v-html="data.text"/>

                </div>

            </Column>

            <Column :span="[ 2, 5 ]" :push="[ 0, 1 ]" class="mt-9">

                <Paragraph v-html="data.author" no-margin/>

                <Paragraph v-html="data.position"/>

                <img class="mt-5" :src="data?.logo?.permalink" alt="" width="80"/>

            </Column>

        </AOS>

    </Grid>

</template>

<script lang="ts">
    import { defineComponent } from 'vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import Paragraph from './Paragraph.vue'

    export default defineComponent({
        name: 'Testimonial',
        props: {
            data: { type: Object as any, required: true }
        },
        components: {
            Column,
            Grid,
            Paragraph
        }
    })
</script>

<style lang="scss">

    @include component(testimonial) {

        @include part(quote) {

            transition: all 700ms ease;

        }

    }

</style>
